export const STATES_GENERAL_GET_REQUESTING = 'STATES_GENERAL_GET_REQUESTING';
export const STATES_GENERAL_GET_SUCCESS = 'STATES_GENERAL_GET_SUCCESS';
export const STATES_GENERAL_GET_ERROR = 'STATES_GENERAL_GET_ERROR';

export const STATES_CREDIT_GET_REQUESTING = 'STATES_CREDIT_GET_REQUESTING';
export const STATES_CREDIT_GET_SUCCESS = 'STATES_CREDIT_GET_SUCCESS';
export const STATES_CREDIT_GET_ERROR = 'STATES_CREDIT_GET_ERROR';

export const STATE_RESET_STATES = 'STATE_RESET_STATES';